// @ts-ignore
import AMap from 'AMap'

const config: any = {
  size: new AMap.Size(36, 36),
  imageSize: new AMap.Size(36, 36),
  imageOffset: new AMap.Pixel(0, 0)
}

const basic: any = new AMap.Icon({
  image: 'https://cdn-cnc.17zuoye.cn/fs-resource/5df2032582393f43689d72e0.png',
  ...config
})

const house: any = new AMap.Icon({
  image: 'https://cdn-cnc.17zuoye.cn/fs-resource/5df2032582393f43689d72dc.png',
  ...config
})
const school: any = new AMap.Icon({
  image: 'https://cdn-cnc.17zuoye.cn/fs-resource/5df203253cb75ee67e45f45b.png',
  ...config
})
const learn: any = new AMap.Icon({
  image: 'https://cdn-cnc.17zuoye.cn/fs-resource/5df203253cb75ee67e45f455.png',
  ...config
})

const icons: any = {
  basic,
  house,
  school,
  learn
}

export default icons
